import React, { useRef, useState } from 'react';
import styles from "../../../styles/applicant/ApplicantTable.module.css";
import {
    FaFileAlt, FaTimes, FaUser, FaMapMarkerAlt, FaCertificate,
    FaCalendarAlt, FaHome, FaFileDownload, FaUpload
} from "react-icons/fa";

import DocPartPlanAll from '../../AutoDocumentService/DocPartPlanAll';
import DocZoneAll from '../../AutoDocumentService/DocZoneAll';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const ApplicationDetailsModal = ({
    selectedApplication,
    closeApplicationDetails,
    language,
    formatDate,
    handleFieldChange,
    uploadCertificate,
    uploadCertificateMeasurement,
    uploadCertificateFee,
    handleResend,
    uploadingCertificate,
    uploadingCertificateMeasurement,
    uploadingCertificateFee
}) => {
    const letterRefZoneAll = useRef();
    const letterRefAll = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [statusText, setStatusText] = useState('');
    const [progress, setProgress] = useState(0);

    const isEn = language === 'en';
    const isRejected = selectedApplication.status === "rejected" || selectedApplication.status === "reassigned";
    const certification_name_value_not_zone = selectedApplication.certificatename !== "Zone";

    console.log("selected Application : ", selectedApplication);
    const renderDetailField = (label, value) => (
        <div className={styles.detailField}>
            <label>{label}</label>
            <div className={styles.detailValue}>
                {value}
            </div>
        </div>
    );

    const capitalize = (str) => {
        if (str.toLowerCase() === "rejected") {
            return "Reassigned";
        }
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    const handleDownloadPDFZoneAll = async () => {
        console.log(' handleDownloadPDFZoneAll run ');
        const element = letterRefZoneAll.current;

        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
        });

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = pdfWidth;
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;

        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;

        while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
        }

        pdf.save('GovtLetter.pdf');
    };

    const handleDownloadPDFAll = async () => {
        setIsLoading(true);
        setStatusText('Please wait, PDF is generating...');
        setProgress(10);

        try {
            const refs = [letterRefAll];
            const pdf = new jsPDF('p', 'mm', 'a4');

            for (let i = 0; i < refs.length; i++) {
                const element = refs[i].current;
                setProgress(10 + i * 40);

                const canvas = await html2canvas(element, {
                    scale: 2,
                    useCORS: true,
                });

                const imgData = canvas.toDataURL('image/png');
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgWidth = pdfWidth;
                const imgHeight = (canvas.height * pdfWidth) / canvas.width;

                let heightLeft = imgHeight;
                let position = 0;

                if (i > 0) pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pdfHeight;

                while (heightLeft > 0) {
                    position = heightLeft - imgHeight;
                    pdf.addPage();
                    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pdfHeight;
                }
            }

            setProgress(90);
            await new Promise(resolve => setTimeout(resolve, 500));
            pdf.save('GovtLetter.pdf');
            setTimeout(() => {
                setIsLoading(false);
            }, 3000);
        } catch (error) {
            console.error('Error generating PDF:', error);
            setTimeout(() => {
                setIsLoading(false);
            }, 3000);
        }
    };

    const allHandleDownloadPDF = async () => {
        console.log('allHandleDownloadPDF a');
        if (selectedApplication.certificatename == 'Zone') {
            handleDownloadPDFZoneAll();
        } else {
            console.log('allHandleDownloadPDF b');
            handleDownloadPDFAll();
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContainer}>
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>
                        <FaFileAlt className={styles.modalIcon} />
                        {isEn ? 'Application Details' : 'अर्ज तपशील'}
                    </h2>
                    <button
                        className={styles.modalCloseButton}
                        onClick={closeApplicationDetails}
                        aria-label="Close modal"
                    >
                        <FaTimes />
                    </button>
                </div>

                <div className={styles.modalContent}>
                    <div className={styles.modalColumn}>
                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <FaUser className={styles.sectionIcon} />
                                {isEn ? 'Applicant Information' : 'अर्जदाराची माहिती'}
                            </h3>
                            {renderDetailField(isEn ? 'Name' : 'नाव', selectedApplication.applicantName)}
                            {renderDetailField(isEn ? 'Email' : 'ईमेल', selectedApplication.applicantEmail)}
                            {renderDetailField(isEn ? 'Mobile' : 'मोबाइल', selectedApplication.applicantMobile)}
                            {renderDetailField(isEn ? 'Address' : 'पत्ता', selectedApplication.applicantAddress)}
                        </div>

                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <FaMapMarkerAlt className={styles.sectionIcon} />
                                {isEn ? 'Location Details' : 'स्थान तपशील'}
                            </h3>
                            {renderDetailField(isEn ? 'Division' : 'विभाग', "Pune")}
                            {renderDetailField(isEn ? 'District' : 'जिल्हा', "Sangli")}
                            {/* {renderDetailField(isEn ? 'Taluka' : 'तालुका', selectedApplication.taluka)} */}
                            {renderDetailField(isEn ? 'Village' : 'गाव', selectedApplication.village)}
                        </div>

                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <FaCertificate className={styles.sectionIcon} />
                                {isEn ? 'Documents' : 'दस्तऐवज'}
                            </h3>
                            {renderDetailField(isEn ? 'Service Type' : 'प्रमाणपत्र प्रकार', selectedApplication.certificatename)}
                            {renderDetailField(
                                isEn ? 'Certificate' : 'प्रमाणपत्र',
                                selectedApplication.certificatePath ? (
                                    <a
                                        href={`${process.env.REACT_APP_SERVER_URL}/${selectedApplication.certificatePath}`}
                                        download
                                        className={styles.fileLink}
                                    >
                                        <FaFileDownload /> {isEn ? 'Download' : 'डाउनलोड'}
                                    </a>
                                ) : (selectedApplication.approved_m_or_a === 'automatic' ? (
                                    <a
                                        className={styles.fileLink}
                                        onClick={allHandleDownloadPDF}
                                    >
                                        <FaFileDownload /> {isEn ? 'Download' : 'डाउनलोड'}
                                    </a>
                                ) : (
                                    isEn ? 'Not Available' : 'उपलब्ध नाही'
                                ))
                            )}
                        </div>
                    </div>

                    <div className={styles.modalColumn}>
                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <FaCalendarAlt className={styles.sectionIcon} />
                                {isEn ? 'Application Timeline' : 'अर्ज वेळरेषा'}
                            </h3>
                            {renderDetailField(isEn ? 'Submission Date' : 'सबमिशन तारीख', formatDate(selectedApplication.dateOfIssue))}
                            {renderDetailField(isEn ? 'Approval Date' : 'मंजुरी तारीख', formatDate(selectedApplication.dateOfAction))}
                            {renderDetailField(isEn ? 'Status' : 'स्थिती',
                                <span className={`${styles.detailValue} ${styles[selectedApplication.status.toLowerCase()]}`}>
                                    {isEn ? capitalize(selectedApplication.status) :
                                        (selectedApplication.status === "Pending" ? "प्रलंबित" :
                                            selectedApplication.status === "Approved" ? "मंजूर" : "नाकारले")}
                                </span>
                            )}
                            {renderDetailField(isEn ? 'Remark' : 'शेरा ', selectedApplication.remark)}
                        </div>

                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <FaHome className={styles.sectionIcon} />
                                {isEn ? 'Property Details' : 'मालमत्तेचे तपशील'}
                            </h3>

                            {isRejected ? (
                                <div className={styles.formGroup}>
                                    <label>{isEn ? 'Survey Number' : 'सर्व्हे नंबर'}</label>
                                    <input
                                        type="text"
                                        value={selectedApplication.surveyNumber || ''}
                                        onChange={(e) => handleFieldChange('surveyNumber', e.target.value)}
                                        className={styles.editableInput}
                                    />
                                </div>
                            ) : (
                                renderDetailField(isEn ? 'Survey Number' : 'सर्व्हे नंबर', selectedApplication.surveyNumber)
                            )}

                            {renderDetailField(isEn ? '7/12 Extract/C.T.Survey/Gunthewari Certificate(with Old & New Survey Numbers)' : '७/१२ उतारा',
                                selectedApplication.satbaraAttachment ? (
                                    <a
                                        href={`${process.env.REACT_APP_SERVER_URL}/${selectedApplication.satbaraAttachment}`}
                                        download
                                        className={styles.fileLink}
                                    >
                                        <FaFileDownload /> {isEn ? 'Download' : 'डाउनलोड'}
                                    </a>
                                ) : (isEn ? 'Not Available' : 'उपलब्ध नाही')
                            )}

                            {renderDetailField(isEn ? 'Measurement Sheet/C.T.Survey Map/Layout/Gunthewari Plot Map' : 'मोजणी पत्रक',
                                selectedApplication.meausurementAttachment ? (
                                    <a
                                        href={`${process.env.REACT_APP_SERVER_URL}/${selectedApplication.meausurementAttachment}`}
                                        download
                                        className={styles.fileLink}
                                    >
                                        <FaFileDownload /> {isEn ? 'Download' : 'डाउनलोड'}
                                    </a>
                                ) : (isEn ? 'Not Available' : 'उपलब्ध नाही')
                            )}



                            {/* 
                            {certification_name_value_not_zone && renderDetailField(isEn ? 'Measurement Sheet' : 'मोजणी पत्रक',
                                selectedApplication.meausurementAttachment ? (
                                    <a
                                        href={`${process.env.REACT_APP_SERVER_URL}/${selectedApplication.meausurementAttachment}`}
                                        download
                                        className={styles.fileLink}
                                    >
                                        <FaFileDownload /> {isEn ? 'Download' : 'डाउनलोड'}
                                    </a>
                                ) : (isEn ? 'Not Available' : 'उपलब्ध नाही')
                            )} */}
                            {/* {certification_name_value_not_zone && renderDetailField(isEn ? 'Measurement Sheet' : 'मोजणी पत्रक',
                                selectedApplication.meausurementAttachment ? (
                                    <a
                                        href={`${process.env.REACT_APP_SERVER_URL}/${selectedApplication.meausurementAttachment}`}
                                        download
                                        className={styles.fileLink}
                                    >
                                        <FaFileDownload /> {isEn ? 'Download' : 'डाउनलोड'}
                                    </a>
                                ) : (isEn ? 'Not Available' : 'उपलब्ध नाही')
                            )} */}

                            {isRejected && (
                                <div className={styles.formGroup}>
                                    <label>{isEn ? 'Upload Measurement Sheet/C.T.Survey Map/Layout/Gunthewari Plot Map Again' : 'मोजणी पत्रक पुन्हा अपलोड करा'}</label>
                                    <label className={styles.uploadButton}>
                                        {uploadingCertificateMeasurement ? (
                                            isEn ? 'Uploading...' : 'अपलोड करत आहे...'
                                        ) : (
                                            <>
                                                <FaUpload /> {isEn ? 'Select File' : 'फाइल निवडा'}
                                                <input
                                                    type="file"
                                                    onChange={uploadCertificateMeasurement}
                                                    className={styles.fileInput}
                                                    disabled={uploadingCertificateMeasurement}
                                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                />
                                            </>
                                        )}
                                    </label>
                                </div>
                            )}

                            {isRejected && (
                                <div className={styles.formGroup}>
                                    <label>{isEn ? 'Upload 7/12 Extract/C.T.Survey/Gunthewari Certificate(with Old & New Survey Numbers) Again' : '७/१२ उतारा पुन्हा अपलोड करा'}</label>
                                    <label className={styles.uploadButton}>
                                        {uploadingCertificate ? (
                                            isEn ? 'Uploading...' : 'अपलोड करत आहे...'
                                        ) : (
                                            <>
                                                <FaUpload /> {isEn ? 'Select File' : 'फाइल निवडा'}
                                                <input
                                                    type="file"
                                                    onChange={uploadCertificate}
                                                    className={styles.fileInput}
                                                    disabled={uploadingCertificate}
                                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                />
                                            </>
                                        )}
                                    </label>
                                </div>
                            )}
                        </div>

                        <div className={styles.section}>
                            <h3 className={styles.sectionTitle}>
                                <FaCalendarAlt className={styles.sectionIcon} />
                                {isEn ? 'Payment Details' : 'पेमेंट तपशील'}
                            </h3>

                            {renderDetailField(isEn ? 'Fee Recipt' : 'फी पावती',
                                selectedApplication.feeReceiptdocument ? (
                                    <a
                                        href={`${process.env.REACT_APP_SERVER_URL}/${selectedApplication.feeReceiptdocument}`}
                                        download
                                        className={styles.fileLink}
                                    >
                                        <FaFileDownload /> {isEn ? 'Download' : 'डाउनलोड'}
                                    </a>
                                ) : (isEn ? 'Not Available' : 'उपलब्ध नाही')
                            )}

                            {isRejected ? (
                                <div className={styles.formGroup}>
                                    <label>{isEn ? 'Transaction Number' : 'यूटीआर क्रमांक'}</label>
                                    <input
                                        type="text"
                                        value={selectedApplication.utrChequeNo || ''}
                                        onChange={(e) => handleFieldChange('utrChequeNo', e.target.value)}
                                        className={styles.editableInput}
                                    />
                                </div>
                            ) : (
                                renderDetailField(isEn ? 'UTR Number' : 'यूटीआर क्रमांक', selectedApplication.utrChequeNo)
                            )}

                            {isRejected && (
                                <div className={styles.formGroup}>
                                    <label>{isEn ? 'Fee Recipt' : 'फी पावती'}</label>
                                    <label className={styles.uploadButton}>
                                        {uploadingCertificateFee ? (
                                            isEn ? 'Uploading...' : 'अपलोड करत आहे...'
                                        ) : (
                                            <>
                                                <FaUpload /> {isEn ? 'Select File' : 'फाइल निवडा'}
                                                <input
                                                    type="file"
                                                    onChange={uploadCertificateFee}
                                                    className={styles.fileInput}
                                                    disabled={uploadingCertificateFee}
                                                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                />
                                            </>
                                        )}
                                    </label>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className={styles.modalActions}>
                    {isRejected && (
                        <button
                            type="button"
                            className={styles.closeButton}
                            onClick={handleResend}
                            disabled={uploadingCertificate}
                        >
                            {uploadingCertificate
                                ? (isEn ? 'Sending...' : 'पाठवत आहे...')
                                : (isEn ? 'Submit' : 'पुन्हा पाठवा')}
                        </button>
                    )}

                    <button
                        type="button"
                        className={styles.closeButton}
                        onClick={closeApplicationDetails}
                    >
                        {isEn ? 'Close' : 'बंद करा'}
                    </button>
                </div>
            </div>

            <div style={{
                position: 'absolute',
                left: '-9999px',
                top: '0',
                zIndex: -9999,
            }}>
                <div ref={letterRefAll} style={{ width: '210mm', margin: '0 auto' }}>
                    <DocPartPlanAll
                        name={selectedApplication.applicantName}
                        address={selectedApplication.applicantAddress}
                        date={selectedApplication.pending_at}
                        proposalId={selectedApplication.request_unique_id}
                        survey={selectedApplication.surveyNumber}
                        village={selectedApplication.village}
                        signPath={selectedApplication.signature_path}
                    />
                </div>
            </div>

            <div style={{
                position: 'absolute',
                left: '-9999px',
                top: '0',
                zIndex: -9998,
            }}>
                <div ref={letterRefZoneAll} style={{ width: '210mm', margin: '0 auto' }}>
                    <DocZoneAll
                        name={selectedApplication.applicantName}
                        address={selectedApplication.applicantAddress}
                        date={selectedApplication.pending_at}
                        proposalId={selectedApplication.request_unique_id}
                        survey={selectedApplication.surveyNumber}
                        zoneStatement={selectedApplication.zoneStatementValue}
                        signPath={selectedApplication.signature_path}
                    />
                </div>
            </div>
        </div>
    );
};

export default ApplicationDetailsModal;